<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" viewBox="0 0 24 24">
  <g clip-path="url(#chevron-right-double__a)">
    <path d="M9.709 2.265a1 1 0 0 0 0 1.416L18.043 12l-8.334 8.32a1 1 0 0 0 0 1.415l1.563 1.56a1 1 0 0 0 1.413 0l10.606-10.587a1 1 0 0 0 0-1.416L12.685.705a1 1 0 0 0-1.413 0l-1.563 1.56Z"/>
    <path d="M.709 2.265a1 1 0 0 0 0 1.416L9.043 12 .709 20.32a1 1 0 0 0 0 1.415l1.563 1.56a1 1 0 0 0 1.413 0l10.606-10.587a1 1 0 0 0 0-1.416L3.685.705a1 1 0 0 0-1.413 0L.709 2.265Z"/>
  </g>
  <defs>
    <clipPath id="chevron-right-double__a">
      <path d="M0 0h24v24H0z"/>
    </clipPath>
  </defs>
</svg>
